import ApiService from "../utils/ApiService";
import { getParsedNumber } from "../utils/Common";

export const branchDefaultValues = {
  parentRestaurantId: "",
  restaurantName: "",
  branchName: "",
  address: "",
  latitude: "",
  longitude: "",
  kitchenSlipOnly: false,
  openTime: null,
  closeTime: null,
  status: "",
  openDays: [],
  vat: 0,
  serviceCharge: 0,
  paymentOptions: [],
  logo: "",
  offerImage: "",
  bannerImages: [],
  bin: "",
  vatRegNo: "",
  mushak: "",
  loyaltyProgramSettings: {
    isActive: "Off",
    pointBasedSystem: {
      isActive: false,
      pointPerHundredTKSpent: "",
      minRedeemPoint: "",
      redeemRate: 1,
    },
    spentBasedSystem: {
      isActive: false,
      slabs: [
        {
          uuid: crypto.randomUUID(),
          minAmount: "",
          discountPercent: "",
        },
      ],
    },
  },
};

/**
 *
 * @param {*} purpose Values: PAYMENT_METHOD, PAY_LATER, KITCHEN_SLIP
 * @param {*} params
 * @param {*} token
 */
export const updateProfileSettings = async (params, token) => {
  try {
    const payload = {
      restaurantId: params.restaurantId,
      acceptPayAfterEat: params.acceptPayAfterEat ? "YES" : "NO",
      kitchenSlipOnly: params.kitchenSlipOnly ? "YES" : "NO",
      customersPaymentOptions: params.paymentOptions.selectedOptionsCustomers,
      adminsPaymentOptions: params.paymentOptions.selectedOptionsAdmins,
      inventoryType: params.inventoryType,
      invoiceSettingsNameAndLogo: params.invoiceSettingsNameAndLogo,
      loyaltyProgramSettingsRequest: params.loyaltyProgramSettings,
      tableManagement: params.tableManagement,
      takeoutTypes: params.takeoutTypes,
      posBanks: params.posBanks
    };

    const res = await ApiService.UPDATE_PAYMENT_METHOD(payload, token);
    return {
      success: res.code === 200,
      msg: res.code === 200 ? "Data updated successfully." : res.message,
    };
  } catch (error) {
    console.log("--------error---", error);
    return {
      success: false,
      msg: "Faild to update data. Please try again.",
    };
  }
};
export const hasInvalidValuesInCurrentSlab = (slab) => {
  if (getParsedNumber(slab.minAmount) == 0) {
    return "Please provide a valid value for spend field";
  }

  if (getParsedNumber(slab.discountPercent) === 0) {
    return "Please provide a valid value for discount field";
  }

  return "";
}



function validateSlabs(slabs) {
  if (slabs.length <= 1) {
    return "";
  }

  for (let i = 0; i < slabs.length - 1; i++) {
    const current = getParsedNumber(slabs[i].minAmount);
    const next = getParsedNumber(slabs[i + 1].minAmount);

    // Validate discount field also
    const currentDiscunt = getParsedNumber(slabs[i].discountPercent);
    const nextDiscount = getParsedNumber(slabs[i + 1].discountPercent);
    
    if (getParsedNumber(current) === 0) {
      return `Please provide a spend amount for slab# ${i+1}`;
    }

    if (getParsedNumber(next) === 0) {
      return `Please provide a spend amount for slab# ${i + 2}`;
    }

    if (getParsedNumber(currentDiscunt) === 0) {
      return `Please provide a discont value for slab# ${i+1}`;
    }

    if (getParsedNumber(nextDiscount) === 0) {
      return `Please provide a discount value for slab# ${i + 2}`;
    }

    
    if (current >= next) {
      return `Spend amount of slab# ${i+1} cannot be greater than slab# ${i+2} spend amount.`;
    }
  }

  return "";
}

export const validateLoyaltySettings = (loyaltySettings, slabs) => {
  if (
    loyaltySettings.isActive === "On" &&
    !(loyaltySettings.pointBasedSystem.isActive || loyaltySettings.spentBasedSystem.isActive)
  ) {
    return "Please select either point based or spend based or both";
  }

  if (
    loyaltySettings.pointBasedSystem.isActive &&
    getParsedNumber(loyaltySettings.pointBasedSystem.pointPerHundredTKSpent) <= 0
  ) {
    return "Points per 100 TK field needs a valid value when point based checkbox is checked";
  }

  if (
    loyaltySettings.pointBasedSystem.isActive &&
    getParsedNumber(loyaltySettings.pointBasedSystem.minRedeemPoint) <= 0
  ) {
    return "Min points to redeem field needs a valid value when point based checkbox is checked";
  }

  const hasEmptyField = slabs.some(
    (slab) => getParsedNumber(slab.minAmount) == 0 || getParsedNumber(slab.discountPercent) === 0
  );

  if (loyaltySettings.spentBasedSystem.isActive && hasEmptyField) {
    return "Please provide a valid value for all fields as spend based checkbox is checked";
  }

  const slabsValueSeqError = validateSlabs(slabs);

  if (slabsValueSeqError) {
    return slabsValueSeqError;
  }

  return "";
};

export const validateSettingsData = (paymentOptions, loyaltySettings, slabs) => {
  const loyaltySettingsError = validateLoyaltySettings(loyaltySettings, slabs);
  const errors = [];

  if (loyaltySettingsError) {
    errors.push(loyaltySettingsError);
  }

  if (paymentOptions.selectedOptionsCustomers.length === 0) {
    errors.push("At least one customer payment method is required.");
  }

  if (paymentOptions.selectedOptionsAdmins.length === 0) {
    errors.push("At least one restaurant payment method is required.");
  }

  return errors;
};

export const getPaymentOptions = (rawOptions) => {
  return rawOptions.map((option) => {
    switch (option) {
      case "CASH":
        return "Cash";
      case "ONLINE":
        return "Online";
      case "POS":
        return "POS";
      default:
        return option;
    }
  });
};

export const getLoyalProgramFormatedData = (branchRecord) => {
  const loyaltyProgramSettings = { ...branchRecord.loyaltyProgramSettings };
  const pointBasedSystem = loyaltyProgramSettings.pointBasedSystem;
  loyaltyProgramSettings.isActive = loyaltyProgramSettings.isActive ? "On" : "Off";

  loyaltyProgramSettings.pointBasedSystem = {
    ...pointBasedSystem,
    pointPerHundredTKSpent: pointBasedSystem.pointPerHundredTKSpent > 0 ? pointBasedSystem.pointPerHundredTKSpent : "",
    minRedeemPoint: pointBasedSystem.minRedeemPoint > 0 ? pointBasedSystem.minRedeemPoint : "",
  };

  const spentBasedSystem = loyaltyProgramSettings.spentBasedSystem;

  if (spentBasedSystem.slabs.length === 0) {
    loyaltyProgramSettings.spentBasedSystem = {
      ...spentBasedSystem,
      slabs: [{ uuid: crypto.randomUUID(), minAmount: "", discountPercent: "" }],
    };
  } else {
    loyaltyProgramSettings.spentBasedSystem = {
      ...spentBasedSystem,
      slabs: spentBasedSystem.slabs.map((item) => ({ ...item, uuid: crypto.randomUUID() })),
    };
  }

  console.log("============getLoyalProgramFormatedData========called====", { loyaltyProgramSettings, branchRecord });

  return loyaltyProgramSettings;
};

const isEmptyFirstSlab = (slabs) => {
  return getParsedNumber(slabs[0].discountPercent) === 0
}

export const formatLoyaltyProgramSettingsReq = (loyaltyProgramSettings, slabs) => {
  let spentBasedSystem = loyaltyProgramSettings.spentBasedSystem;

  if (slabs.length === 1 && isEmptyFirstSlab(slabs)) {
    spentBasedSystem.slabs = [];
  } else {
    spentBasedSystem.slabs = slabs;
  }

  const tmpLoayaltySettings = { ...loyaltyProgramSettings };
  tmpLoayaltySettings.spentBasedSystem = spentBasedSystem;

  return {
    isActive: tmpLoayaltySettings.isActive === "On" ? "YES" : "NO",
    pointBasedSystem: {
      ...tmpLoayaltySettings.pointBasedSystem,
      isActive: tmpLoayaltySettings.pointBasedSystem.isActive ? "YES" : "NO",
    },
    spentBasedSystem: {
      ...tmpLoayaltySettings.spentBasedSystem,
      isActive: tmpLoayaltySettings.spentBasedSystem.isActive ? "YES" : "NO",
    },
  };
};
